var _style, _defs, _path, _path2, _defs2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "900px",
    height: "600px",
    viewBox: "0 0 900 600",
    style: {
      enableBackground: "new 0 0 900 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000114788119616002028070000017214446057178704289_);}\r\n\t.st1{fill:#012169;}\r\n\t.st2{stroke:#FFFFFF;stroke-width:120;stroke-miterlimit:80;}\r\n\t\r\n\t\t.st3{clip-path:url(#SVGID_00000167354457697393388500000018152068963531867038_);stroke:#C8102E;stroke-width:80;stroke-miterlimit:80;}\r\n\t.st4{stroke:#FFFFFF;stroke-width:200;stroke-miterlimit:80;}\r\n\t.st5{stroke:#C8102E;stroke-width:120;stroke-miterlimit:80;}\r\n\t.st6{fill:none;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 900,
    height: 600
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171700813177405527770000003622542764661279632_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000171700813177405527770000003622542764661279632_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0v600h900V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0l900,600 M900,0L0,600"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000089537509875090339400000015946849162129980837_",
    points: "450,300 900,300 900,600 450,600 0,600 0,300  0,0 450,0 900,0  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150787994365926147050000000313834527250559623_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000089537509875090339400000015946849162129980837_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150787994365926147050000000313834527250559623_)",
      stroke: "#C8102E",
      strokeWidth: 80,
      strokeMiterlimit: 80
    },
    d: " M0,0l900,600 M900,0L0,600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M450,0v600 M0,300h900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M450,0v600 M0,300h900"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.3,
    y: 0.1,
    className: "st6",
    width: 900,
    height: 600
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.8c9557df6d757cb8a9bc6c967a49f98b.svg";
export { ForwardRef as ReactComponent };